import {
  AuditReportsAodNotificationSettingsSchemaPolicyEnum,
  AuditReportsAodRule,
  AuditReportsAodRuleReportTypeEnum,
  AuditReportsAodRuleTriggerEnum,
  AuditReportsAodRun,
  AuditReportsAodRunInGetManyDto,
  AuditReportsAodRunInGetManyDtoStatusEnum,
  AuditReportsAodRunStatusEnum,
  AuditReportsAodRunStatusEnumKey,
  AuditReportsAodRunTypeEnum,
  AuditReportsAodRunUserStatusEnum,
  AuditReportsCreateAodRuleDto,
  AuditReportsGipEvidenceExportOptionsDto,
  AuditReportsGipEvidenceExportOptionsDtoMediaTypeEnumKey,
  AuditReportsGipReportDataDto,
  AuditReportsManualAodRunRequestDto,
  AuditReportsOlafFailedDataDto,
  AuditReportsOlafMissingSegmentsDto,
  AuditReportsOlafMissingSegmentsDtoTypeEnum,
  AuditReportsOlafMissingSpotMediaDto,
  AuditReportsOlafMissingSpotMediaDtoTypeEnum,
  AuditReportsPublicJobDtoStatusEnum,
  AuditReportsScheduledAodRunDto,
} from '@mi-front/api-v2';

export {
  AuditReportsAodNotificationSettingsSchemaPolicyEnum as NotificationSettingsPolicyEnum,
  AuditReportsAodRuleReportTypeEnum as AodRuleReportTypeEnum,
  AuditReportsAodRuleTriggerEnum as AodRuleTriggerEnum,
  AuditReportsAodRunInGetManyDtoStatusEnum as AodRunInGetManyDtoStatusEnum,
  AuditReportsAodRunStatusEnum as AodRunStatusEnum,
  AuditReportsAodRunTypeEnum as AodRunTypeEnum,
  AuditReportsAodRunUserStatusEnum as AodRunUserStatusEnum,
  AuditReportsOlafMissingSegmentsDtoTypeEnum as OlafMissingSegmentsDtoTypeEnum,
  AuditReportsOlafMissingSpotMediaDtoTypeEnum as OlafMissingSpotMediaDtoTypeEnum,
  AuditReportsPublicJobDtoStatusEnum as PublicJobDtoStatusEnum,
};

/** AOD rule returned by the audit reports API. */
export type AodRule = AuditReportsAodRule;
/** Full AOD run returned by the audit reports API. */
export type AodRun = AuditReportsAodRun;
/** Compact AOD run returned by list endpoints. */
export type AodRunInGetManyDto = AuditReportsAodRunInGetManyDto;
/** AOD run status union. */
export type AodRunStatusEnumKey = AuditReportsAodRunStatusEnumKey;
/** Payload used to create an AOD rule. */
export type CreateAodRuleDto = AuditReportsCreateAodRuleDto;
/** GIP evidence export options shared by reports and AOD. */
export type GipEvidenceExportOptionsDto = Omit<
  AuditReportsGipEvidenceExportOptionsDto,
  'mediaType'
> & {
  mediaType?: Exclude<AuditReportsGipEvidenceExportOptionsDtoMediaTypeEnumKey, 'IMAGE'>;
};
/** GIP report configuration used by AOD rules. */
export type GipReportDataDto = Omit<AuditReportsGipReportDataDto, 'clientId'> & {
  clientId?: string;
};
/** Payload used to trigger a manual AOD run. */
export type ManualAodRunRequestDto = AuditReportsManualAodRunRequestDto;
/** Failed OLAF reprocessing result. */
export type OlafFailedDataDto = AuditReportsOlafFailedDataDto;
/** Missing OLAF segments result. */
export type OlafMissingSegmentsDto = AuditReportsOlafMissingSegmentsDto;
/** Missing OLAF spot media result. */
export type OlafMissingSpotMediaDto = AuditReportsOlafMissingSpotMediaDto;
/** Scheduled AOD run returned by scheduled-run endpoints. */
export type ScheduledAodRunDto = AuditReportsScheduledAodRunDto;

/** Conditions that determine whether a GIP report can be exported. */
export interface GipEvidenceExportConditionsDto {
  minEfficiency?: number | false;
}

export const GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnum = {
  PER_RUN: 'PER_RUN',
  PER_RULE: 'PER_RULE',
} as const;

export type GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnumKey =
  (typeof GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnum)[keyof typeof GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnum];

/** GIP evidence options extended with AOD package storage behavior. */
export type GipAodRuleEvidenceExportOptionsDto = GipEvidenceExportOptionsDto & {
  packageStorageStrategy?: GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnumKey;
};

/** GIP-specialized AOD rule shape omitted from the api-v2 specification. */
export type GipAodRuleDto = Omit<
  AuditReportsAodRule,
  'reportConfig' | 'exportOptions' | 'exportConditions'
> & {
  reportConfig: GipReportDataDto;
  exportOptions: GipAodRuleEvidenceExportOptionsDto;
  exportConditions: GipEvidenceExportConditionsDto;
};
